// During the Stripe account migration, customers are on either the original or the BH Ops Stripe account.
// The customer account's Stripe gateway determines which publishable key card tokens are created with.
const getStripePublishableKey = (stripeGateway?: string) => {
  if (stripeGateway && stripeGateway === process.env.REACT_APP_BH_OPS_STRIPE_GATEWAY) {
    return process.env.REACT_APP_BH_OPS_STRIPE_PUBLISHABLE_KEY;
  }
  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
};

export default getStripePublishableKey;
